export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ06.d0b67dae.mp3";